import { render, staticRenderFns } from "./level-update-card.vue?vue&type=template&id=117f90a0&scoped=true&"
import script from "./level-update-card.vue?vue&type=script&lang=ts&"
export * from "./level-update-card.vue?vue&type=script&lang=ts&"
import style0 from "./level-update-card.vue?vue&type=style&index=0&id=117f90a0&lang=scss&scoped=true&"
import style1 from "./level-update-card.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117f90a0",
  null
  
)

export default component.exports